<template>

  <select-dropdown :ref="_uid" @onChange="onChange" />
  
</template>

<script>

  import SelectDropdown from "./select-dropdown.vue"

  export default {

    name: "SelectMonth",

    props: {
      uppercase: { type: Boolean, default: true },
    },
    
    components: {
      SelectDropdown,
    },

    mounted() {

      let months = [
        { id: 1, value: "Janeiro" },
        { id: 2, value: "Fevereiro" },
        { id: 3, value: "Março" },
        { id: 4, value: "Abril" },
        { id: 5, value: "Maio" },
        { id: 6, value: "Junho" },
        { id: 7, value: "Julho" },
        { id: 8, value: "Agosto" },
        { id: 9, value: "Setembro" },
        { id: 10, value: "Outubro" },
        { id: 11, value: "Novembro" },
        { id: 12, value: "Dezembro" },
      ]

      if (this.uppercase)
        months.map((month) => month.value = month.value.toUpperCase())

      this.$refs[this._uid].setValues(months)
    },

    methods: {

      setSelected(month) {      
        this.$refs[this._uid].setSelected(month)
      },

      onChange(month) {
        this.$emit("onChange", month)
      },

      clear() {
        this.$refs[this._uid].clear()
      },

      reset() {
        this.$refs[this._uid].reset()
      },
    },
  }

</script>

